import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Nights lost searching for sessions that actually flow and have real purpose', 'Classes that feel repetitive because you keep falling back on the same practices', 'Visible improvisation in your cueing that is slowly undermining your confidence as a teacher', 'Not knowing exactly when to speak, when to hold silence, or what to say at each moment', 'Groups that feel unsettled or unfocused because the structure is not clear', 'Emergency sessions where you are improvising because your original plan did not work', 'No simple way to track student progress or show what practitioners are actually learning', 'Weekends spent planning instead of resting, recovering, or living your life', 'Constant doubt about whether you are teaching correctly or if there is a better way'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-base" data-id="element-161" data-mp="3nd7k1v5uyivy">
      <div className="max-w-3xl mx-auto" data-id="element-162" data-mp="3nbwg9vcexb4u">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-163" data-mp="1z0exkpa70w3q">
          <p className="text-olive font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-164" data-mp="27v356m38qpvp">
            A Sunday night dilemma
          </p>
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-ink" data-id="element-165" data-mp="1g1atluxidsix">
            Sound familiar?
          </h2>
          <p className="text-lg text-graphite leading-relaxed bg-cream-light p-6 rounded-2xl border border-silver-light text-left" data-id="element-166" data-mp="1b416ilxldsy9">
            Sunday night. 10 PM. You have a mindfulness and meditation class tomorrow morning. And
            you&apos;re still sitting there — searching for sessions that actually work, trying to
            build a sequence that flows naturally, wondering what to say, when to create silence,
            how to adapt the practice if the group arrives tense or tired.
            <br data-id="element-167" data-mp="1t4dh33et1a8u" />
            <br data-id="element-168" data-mp="1t4vgg8wrk4kz" />
            <span className="text-brand-dark font-semibold" data-id="element-169" data-mp="1t7hnm7fqsi2o">
              Not because you don&apos;t know mindfulness and meditation.
            </span>{' '}
            You already know mindfulness and meditation. Because no one ever gave you a complete,
            ready-to-teach library. You&apos;ve been building every session from scratch. The time
            you should be resting, you&apos;re spending on planning — and walking into class wishing
            you&apos;d been better prepared.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="space-y-6" data-id="element-170" data-mp="1jf3l3cgub7fg">
          <h3 className="text-xl font-bold text-ink mb-8 text-center" data-id="element-171" data-mp="qoll4kbexm69">
            The real cost of not having the right resource:
          </h3>
          <ul className="space-y-4" data-id="element-172" data-mp="o6i7kxrv5quy">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-paper p-4 rounded-xl border border-silver-light" data-id="element-173" data-mp="j6ngat46ez9d" data-mpi={index}>
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" aria-hidden="true" data-id="element-174" data-mp="ge1mjr7df0s" />
                <span className="text-graphite" data-id="element-175" data-mp="3rkm9jmzrk6j6">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-silver-light" data-id="element-176" data-mp="3imak3oamvesb">
            <p className="text-2xl font-display font-extrabold text-brand-dark" data-id="element-177" data-mp="3iodd8h731o19">
              Stop giving away your free time. Your dedication is already there. What you need now
              is the right tool.
            </p>
            <p className="text-xl mt-4 text-ink" data-id="element-178" data-mp="1llefl0dw3plo">
              Plan an entire year of mindfulness and meditation classes today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}